/**
 * 318: the MapTiler key for the Gallery map, per Netlify context
 * (VITE_MAPTILER_KEY). A public client key, restricted in MapTiler's dashboard
 * to our origins. Its own module because import.meta.env does not exist in the
 * test bundle, and lib/galleryMap.ts is imported by the suite.
 * Empty = the outline map, no vendor.
 */
export const MAPTILER_KEY: string | null = (import.meta.env.VITE_MAPTILER_KEY ?? '').trim() || null
